export default __webpack_public_path__ + "static/media/whatsapp-icon.c47498eb.svg";